import { request } from '@blade/common';
/**
  * 批量上传附件
  */
export const batchAddDevice = (data) => request({
    url: `/api/iot-device-management/api/v1/dahua/iot/batchAddDevice`,
    method: 'POST',
    data,
    headers: {
        'Content-Type': 'multipart/form-data;'
    }
});
// 新增节点数据
// export const devicesTypes = () =>
//   request({
//     url: '/api/iot-device-management/api/v1/device-groups/add',
//     method: 'POST',
//     data: {}
//   });
